import { useState } from 'react';
import Dropdown from '../../common/Dropdown/Dropdown';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';
import S from './DashboardWidgetMenuStyles';

type Props = {
  onMove?: () => void;
  onRemove?: () => void;
  onViewAll?: () => void;
};

function DashboardWidgetMenu({ onMove, onRemove, onViewAll }: Props): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const runAction = (action?: () => void): void => {
    setIsOpen(false);
    action?.();
  };

  return (
    <S.Wrapper>
      <Dropdown
        isOpen={isOpen}
        onChange={setIsOpen}
        target={(
          <button type="button" className="dashboard-widget-menu-trigger" aria-label="Widget options">
            <Icon iconKey={IconKeys.EXTEND} />
          </button>
        )}
      >
        <ul className="dashboard-widget-menu">
          {onViewAll && (
            <li>
              <button type="button" onClick={() => runAction(onViewAll)}>
                <Icon iconKey={IconKeys.VIEW_ALL} />
                <span>View all</span>
              </button>
            </li>
          )}
          {onMove && (
            <li>
              <button type="button" onClick={() => runAction(onMove)}>
                <Icon iconKey={IconKeys.MOVE} />
                <span>Move</span>
              </button>
            </li>
          )}
          {onRemove && (
            <li>
              <button type="button" onClick={() => runAction(onRemove)}>
                <Icon iconKey={IconKeys.DELETE} />
                <span>Remove</span>
              </button>
            </li>
          )}
        </ul>
      </Dropdown>
    </S.Wrapper>
  );
}

export default DashboardWidgetMenu;
